module.exports = __webpack_public_path__ + "static/fr-1-d0551dfa817bbd46c16151ffb2c49298.mp4";